const baseUrl = '/api/customer/flagged-content'

export default {
    send(data) {
        return axios.post(baseUrl, data)
    },
}
